<bzg-modal-header>
    <div class="bmc-deployment-confirm__header">
        <span>{{ 'DEPLOYMENT.CONFIRM_TITLE' | translate }}</span>
        <bzg-button-icon icon="icon-close" (click)="close()"></bzg-button-icon>
    </div>
</bzg-modal-header>
<bzg-modal-content>
    <div>
        <span class="bmc-deployment-confirm__text bz-space--stack-m">{{ 'DEPLOYMENT.CONFIRM_TEXT' | translate }}</span>
        <div
            class="bmc-deployment-confirm-file bz-color-border--neutral-400 bz-color-bg--neutral-200 bz-space--inset-squish-s">
            <bzg-icon [size]="30" [nameIcon]="'bex-file'" class="bz-space--inline-m" [color]="'dark'">
            </bzg-icon>
            <div class="bmc-deployment-confirm-file__info-wrapper">
                <strong>{{ data.fileName }}</strong>
                <span class="bz-font-size--body-small">{{ data.fileDate }}</span>
            </div>
        </div>
    </div>
</bzg-modal-content>
<bzg-modal-footer class="bmc-delete-alert__footer">
    <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{ 'GLOBAL.CANCEL' | translate }}
    </bzg-button-secondary>
    <bzg-button-primary (click)="confirm()">{{ 'DEPLOYMENT.UPLOAD_PACKAGE' | translate }}</bzg-button-primary>
</bzg-modal-footer>